import React, { ReactNode } from 'react';
import styled from 'styled-components';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../context/ProductBuilder/machine';
import { getBaseProductType } from '../../../helpers/getBaseProductType';
import { getProductHelpTextConfig } from '../../../helpers/getProductHelpTextConfig';
import { getStateKey } from '../../../helpers/getStateKey';
import { HelpTooltip } from '../../Icon';
import { HelpTextModal } from '../../ProductBuilder/HelpTextModal/HelpTextModal';

type Props = {
  children: ReactNode | ReactNode[];
};

const StyledHeading = styled.h1`
  margin: 0;
  text-align: center;
  font: normal normal bold 20px/24px Lato;
  letter-spacing: 2.06px;
  color: #242325;
`;

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

const StyledProductSummary = styled.span`
  width: 42px;
  height: 42px;
  padding-left: 12px;
  border: none;
  cursor: pointer;
  display: none;
  
  @media (min-width: 768px) {
    display: flex;
  }
`;

export const Heading = ({ children }: Props) => {
  const [state] = useService(productBuilderMachine);
  const [isHelpTextModal, setIsHelpTextModal] = React.useState(false);
  const productType = getBaseProductType(state.context);
  const stateKey = getStateKey(state.value);
  const description = getProductHelpTextConfig(productType, stateKey);

  const openHelpTextModal = () => {
    if (description) setIsHelpTextModal(true);
  };

  const closeHelpTextModal = () => {
    setIsHelpTextModal(false);
  };
  return (
    <StyledWrapper>
      <StyledHeading>{children}</StyledHeading>
      {/* {description && (
        <StyledProductSummary onClick={openHelpTextModal}>
          <HelpTooltip />
        </StyledProductSummary>
      )} */}
      <HelpTextModal
        modalIsOpen={isHelpTextModal}
        openModal={openHelpTextModal}
        closeModal={closeHelpTextModal}
        description={description}
      />
    </StyledWrapper>
  );
};
